import { Action } from 'redux';
import { Provider } from '../entities/provider';

export enum TProvider {
  SET_PROVIDER = 'SET_PROVIDER',
  FETCH_PROVIDER = 'FETCH_PROVIDER'
}

export interface ISetProvider extends Action {
  type: TProvider.SET_PROVIDER;
  payload: Provider[];
}

export const ASetProvider = (payload: Provider[]): ISetProvider => ({ type: TProvider.SET_PROVIDER, payload });

export interface IFetchProvider extends Action {
  type: TProvider.FETCH_PROVIDER;
}
export const AFetchProvider = (): IFetchProvider => ({ type: TProvider.FETCH_PROVIDER });
